export default __webpack_public_path__ + "static/media/Messages.32bbe133.svg";